import { Divider, Typography } from '@material-ui/core';
import React from 'react';

const DialogHeader = (props) => {
  const { header } = props;
  return (
    <React.Fragment>
      <Typography
        style={{
          whiteSpace: 'nowrap',
          fontSize: '1.5rem',
          fontWeight: '500',
          paddingBottom: '10px',
          justifySelf: 'flex-start',
        }}
      >
        {header ? header : ''}
      </Typography>
      <Divider style={{ marginBottom: '1rem', background: 'black' }} />
    </React.Fragment>
  );
};

export default DialogHeader;
